module.exports = __webpack_public_path__ + "assets/img/Back_002.e130e206-ps.jpg";